import pulse from '@finn-no/pulse-sdk';
import { PulseRecommendation, PulseTrackingContext } from '../data/recommendationDataTypes.ts';

export default class PulseTracking {
    position: string;
    enabled: boolean;
    trackingContext: PulseTrackingContext;

    constructor({
        position = '',
        trackingContext = {},
    }: {
        position?: string;
        trackingContext?: PulseTrackingContext;
    } = {}) {
        this.position = position;
        this.enabled = !!position;
        this.trackingContext = trackingContext;
    }

    trackItemToPulseBasedOnContext(
        itemContext: PulseRecommendation,
        keyWord: 'Click' | 'View',
        trackingContext: PulseTrackingContext,
    ): void {
        if (!this.enabled) {
            console.error(`ignored ${keyWord} tracking to Pulse`, itemContext, trackingContext);
            return;
        }
        if (!itemContext || !trackingContext) return;
        for (const [contextKey, contextValue] of Object.entries(trackingContext)) {
            const event = itemContext[contextKey]?.find((candidate) => candidate.type === keyWord);
            if (event && contextValue) {
                event[contextKey] = contextValue;
                pulse.trackEvent(event, {
                    disableAddClassifiedAdToItems: true,
                });
            }
        }
    }

    trackInscreenWithPulse(item: PulseRecommendation) {
        this.trackItemToPulseBasedOnContext(item, 'View', this.trackingContext);
    }

    trackClickWithPulse(item: PulseRecommendation) {
        this.trackItemToPulseBasedOnContext(item, 'Click', this.trackingContext);
    }
}
